<template>

  <div class="page">

    <div class="top"></div>

  <!-- block开始 -->
  <div class="content-block">

    <div class="main">

      <div class="bg">

        <div class="gift-list">
          <Gift
            v-for="(config, index) in configs"
            @finished="isFinished"
            :trigger="trigger"
            :config="config"
            :key="index"
            :isWin="isWin"
          >
          </Gift>
        </div>

        <div :class="['handler', { 'active': active }, { 'disabled': disabled }]">
          <a href="javascript:;"
            class="btn-recreation"
            @click="!disabled && turn()">
          </a>
        </div>
      
      </div>

      <div class="btns">
        <div class="btn back1" @click="back1"></div>
        <div class="btn back2" @click="back2"></div>
      </div>

      <!-- <div class="btn-create">
        <div class="btn" @click="back"></div>
      </div> -->

    </div>

  <!-- block结束 -->
  </div>

  <!-- 中间结果 -->
  <van-popup v-model="showPop" :close-on-click-overlay="isWin==1 ? false : true">

    <div :class="['win', prizeClass]" v-if="isWin==1">

      <div class="type">{{ prizeType }}</div>

      <div class="name">
        <div class="text" v-html="prizeName"></div>
      </div>

      <div class="input-name">
        <van-field v-model="name" label="" placeholder="请输入您的姓名" />
      </div>

      <div class="input-mobile">
        <van-field v-model="mobile" type="number" label="" placeholder="请输入您的手机号" />
      </div>

      <div class="input-address">
        <van-field v-model="address" type="textarea" placeholder="请输入您的邮寄地址" />
      </div>

      <div class="btn-submit" @click="confirm" ></div>

    </div>

    <div class="lose" v-else></div>

  </van-popup>

  </div>

</template>

<script>
import { Toast } from "vant";
import Gift from '@/components/Gift.vue'
import { getStatus, doLottery, submitInfo } from "@/api/index";
export default {
  props: [],
  data() {
    return {
      showPop: false,
      isWin: 0,
      prize: '',
      prizeClass: 'prize',

      run3D: false,
      trigger: null,
      active: false,
      disabled: false,
      configs: [
        {
          style: 'gift-style',
          gifts: [
            {type:'image',name:'1',path:require("@/images/lottery/prize/p1.png")},
            {type:'image',name:'2',path:require("@/images/lottery/prize/p2.png")},
            {type:'image',name:'3',path:require("@/images/lottery/prize/p3.png")},
            {type:'image',name:'4',path:require("@/images/lottery/prize/p4.png")},
            {type:'image',name:'5',path:require("@/images/lottery/prize/p5.png")},
            {type:'image',name:'6',path:require("@/images/lottery/prize/p6.png")},
            {type:'image',name:'7',path:require("@/images/lottery/prize/p7.png")},
            {type:'image',name:'8',path:require("@/images/lottery/prize/p8.png")}
          ],
          duration: 4000,
          fontSize: 50,
          height: 172,
          width: 85
        },
        {
          style: 'gift-style',
          gifts: [
            {type:'image',name:'1',path:require("@/images/lottery/prize/p1.png")},
            {type:'image',name:'2',path:require("@/images/lottery/prize/p2.png")},
            {type:'image',name:'3',path:require("@/images/lottery/prize/p3.png")},
            {type:'image',name:'4',path:require("@/images/lottery/prize/p4.png")},
            {type:'image',name:'5',path:require("@/images/lottery/prize/p5.png")},
            {type:'image',name:'6',path:require("@/images/lottery/prize/p6.png")},
            {type:'image',name:'7',path:require("@/images/lottery/prize/p7.png")},
            {type:'image',name:'8',path:require("@/images/lottery/prize/p8.png")}
          ],
          duration: 5000,
          fontSize: 50,
          height: 172,
          width: 85
        },
        {
          style: 'gift-style',
          gifts: [
            {type:'image',name:'1',path:require("@/images/lottery/prize/p1.png")},
            {type:'image',name:'2',path:require("@/images/lottery/prize/p2.png")},
            {type:'image',name:'3',path:require("@/images/lottery/prize/p3.png")},
            {type:'image',name:'4',path:require("@/images/lottery/prize/p4.png")},
            {type:'image',name:'5',path:require("@/images/lottery/prize/p5.png")},
            {type:'image',name:'6',path:require("@/images/lottery/prize/p6.png")},
            {type:'image',name:'7',path:require("@/images/lottery/prize/p7.png")},
            {type:'image',name:'8',path:require("@/images/lottery/prize/p8.png")}
          ],
          duration: 6000,
          fontSize: 50,
          height: 172,
          width: 85
        }
      ],
      openResultList: false,
      resultList: [],
      result: [],

      name: "",
      mobile: "",
      address: "",
      isInfo: false,
      isLottery: false,
      isReward: false,
      prizeName: '',
      prizeType: '',
      autosize: { maxHeight: 80, minHeight: 40 }
    };
  },
  computed: {
  },
  components: {
    Gift,
  },
  mounted () {
    this.getStatus();
  },
  methods: {
    getStatus() {
      getStatus().then((res) => {
        console.log(res)
        let { isWin, isInfo, isLottery, isReward, prizeType, prizeName } = res.data;
        if ( isReward && !isInfo ) {
          this.showPop = true
        }

        this.isWin     = isWin
        this.isLottery = isLottery
        this.prizeType = prizeType
        this.prizeName = prizeName
      });
    },
    confirm() {
      let { name, mobile, address } = this;
      if (!name) {
        Toast.fail("请输入姓名");
        return;
      }
      if (!mobile) {
        Toast.fail("请输入手机号");
        return;
      }
      if (!address) {
        Toast.fail("请输入地址");
        return;
      }
      let params = { name, mobile, address }

      submitInfo(params).then((res)=>{
        if ( res.data.success ) {
          this.showPop = false
          Toast.success(res.data.msg);
        } else {
          Toast.fail(res.data.msg);
          return;
        }
      })
    },

    turn () {
      if ( this.isLottery ) {
        Toast.fail('你已经抽过了');
        return;
      }

      var _this = this
      doLottery().then((res) => {
        console.log(res);
        if ( res.data.success ) {
          _this.active = true
          setTimeout(() => {
            _this.active = false
          }, 500)
          _this.disabled = true
          _this.trigger = new Date()

          _this.isWin = res.data.isWin
          _this.prize = res.data.prize
          _this.prizeType = res.data.prizeType
          _this.prizeName = res.data.prizeName
          _this.prizeClass = 'prize'+res.data.prize
          // 已抽过状态
          _this.isLottery = true;
        } else {
          Toast.fail(res.data.msg);
          // Toast(res.data.msg);
        }
      });
    },
    isFinished (val) {
      console.log(val)
      const autoTurnList = this.$el.querySelectorAll('.autoTurn')
      this.result.push(val)
      if (autoTurnList.length === 1) {
        this.disabled = false
        this.resultList.push(this.result)
        this.result = []

        this.showPop = true
      }
      console.log(111)
    },
    // start () {
    //   this.$refs.game.start(this.opts)
    // },
    // reset () {
    //   this.$refs.game.reset()
    // },
    // onComplete (result) {
    //   console.log(result)
    // },
    // 返回画板
    back1() {
      this.$emit("prev");
    },
    // 返回首页
    back2() {
      this.$emit("back");
    }
  },
};
</script>

<style scoped lang="less">
/deep/.van-cell {
  color: #ffda02 !important;
  height: 40px !important;
  line-height: 40px !important;
  padding: 0;
  background-color: transparent !important;
  border: 0 none;
  color: #FFF;
}
/deep/.van-field__control::placeholder {
  // font-family: 'zpix';
  color: #ccc !important;
}
/deep/.van-field__control {
  color: #FFF !important;
  // line-height: 40px !important;
  // background-color: transparent !important;
  // font-size: 28px;
  // border: 0 none;
}
.van-popup {
  background-color: transparent;
  .win {
    width: 634px;
    // height: 615px;
    height: 889px;
    position: relative;

    background: transparent url("../images/lottery/bg-info.png") center center no-repeat;
    background-size: 100%;
    div {
      position: absolute;
      font-size: 28px;
    }
    .type {
      top: 165px;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 150px;
      height: 40px;
      text-align: center;
      color: #ffda02;
      // border: 1px solid red;
    }
    .name {
      top: 205px;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 450px;
      height: 58px;
      display:flex;
      align-items: center;
      justify-content:center;
      .text {
        text-align: center;
        font-size: 20px;
        color: #FFF;
      }
    }
    .input-name {
      top: 379px;
      left: 170px;
      width: 330px;
      height: 40px;
      text-align: left;
      color: #FFF;
      // border: 1px solid red;
    }
    .input-mobile {
      top: 500px;
      left: 230px;
      width: 320px;
      height: 40px;
      text-align: left;
      color: #FFF;
      // border: 1px solid red;
    }
    .input-address {
      top: 645px;
      left: 231px;
      width: 340px;
      height: 40px;
      text-align: left;
      color: #FFF;
      // border: 1px solid red;
    }
    .btn-submit {
      top: 768px;
      left: 56px;
      width: 525px;
      height: 62px;
      text-align: left;
      color: #FFF;
      // border: 1px solid red;
    }
  }
  // .prize1 {
  //   background: transparent url("../images/lottery/layer-win1.png") center center no-repeat;
  //   background-size: 100%;
  // }
  // .prize2 {
  //   background: transparent url("../images/lottery/layer-win2.png") center center no-repeat;
  //   background-size: 100%;
  // }
  // .prize3 {
  //   background: transparent url("../images/lottery/layer-win3.png") center center no-repeat;
  //   background-size: 100%;
  // }
  .lose {
    width: 634px;
    height: 345px;
    background: transparent url("../images/lottery/layer-lose.png") center center no-repeat;
    background-size: 100%;
    position: relative;
  }
}
.gift-list {
  width: 529px;
  height: 343px;
  overflow: hidden;
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.comp-game {
  // border: 1px solid red;
  width: 520px;
  height: 343px;
  box-sizing: border-box;
  overflow: hidden;
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  margin: 0 auto;
  justify-content: space-between;
  .comp-game-item {
    width: 170px !important;
    height: 344px !important;
    background-size: 170px 344px !important;
  }
}

.btn-recreation {
  position: absolute;
  width: 574px;
  height: 80px;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 676px;
  // background-color: red;
}
.page {
  height: 100vh;
  background: url("../images/bg.png") left bottom no-repeat;
  background-size: 750px 1500px;
  position: relative;
  overflow: hidden;
  .content-block {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 1200px;
    top: 50%;
    margin-top: -600px;
  }
}
.top {
  z-index: 2;
  position: absolute;
  top: 0;
  // bottom: 80%;
  width: 751px;
  height: 233px;
  background: url("../images/title-prize.png") no-repeat;
  background-size: 100%;
}
.main {
  z-index: 3;
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 3%;
  margin: 0 auto;
  box-sizing: border-box;
  .bg {
    width: 671px;
    height: 790px;
    background: url("../images/bg/bg-lottery.png") no-repeat;
    background-size: 100%;
    margin: 0 auto 50px;
    .big {
      position: absolute;
      top: 240px;
      left: 182px;
      // right: 0;
      // margin: 0 auto;
      width: 390px;
      height: 336px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      .swiper-slide {
        width: 390px;
      height: 336px;
        float: left;  
      }
    }
  }

  .btns {
    // z-index: 5;
    // position: absolute;
    // bottom: 5%;
    // left: 0;
    // right: 0;
    // width: 540px;
    // height: 75px;
    width: 730px;
    height: 73px;
    box-sizing: border-box;
    padding: 0 123px;
    background: url("../images/btn-bg3.png") no-repeat center center;
    background-size: 730px 28px;

    text-align: center;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .btn {
      width: 240px;
      height: 73px;
    }
    .back1 {
      background: url("../images/lottery/btn-back1.png") no-repeat;
      background-size: 100%;
    }
    .back2 {
      width: 237px;
      height: 72px;
      background: url("../images/lottery/btn-back2.png") no-repeat;
      background-size: 100%;
    }
  }
  // .btn-create {
  //   width: 647px;
  //   height: 91px;
  //   background: url("../images/btn-bg2.png") no-repeat center center;
  //   background-size: 647px 36px;
  //   text-align: center;
  //   margin: 0 auto;
  //   .btn {
  //     width: 299px;
  //     height: 91px;
  //     margin: 0 auto;
  //     background: url("../images/lottery/btn-back.png") no-repeat;
  //     background-size: 100%;
  //   }
  // }
}
</style>
